import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
}

const Icon: React.FC<IconProps & { children: React.ReactNode }> = ({ size = 16, color = 'currentColor', children }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

// --- Bedrijven (AnalysisSidebar + BedrijvenOverpassSection) ---

export const KantorenIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><rect x="4" y="2" width="16" height="20" rx="2" /><line x1="9" y1="6" x2="9" y2="6.01" /><line x1="15" y1="6" x2="15" y2="6.01" /><line x1="9" y1="10" x2="9" y2="10.01" /><line x1="15" y1="10" x2="15" y2="10.01" /><line x1="9" y1="14" x2="9" y2="14.01" /><line x1="15" y1="14" x2="15" y2="14.01" /><rect x="9" y="18" width="6" height="4" /></Icon>
);

export const RetailIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></Icon>
);

export const IndustrieIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M2 20h20" /><path d="M5 20V8l5 4V8l5 4V4h4a1 1 0 0 1 1 1v15" /><line x1="22" y1="4" x2="22" y2="4.01" /></Icon>
);

export const ZorgIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><rect x="3" y="3" width="18" height="18" rx="2" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" /></Icon>
);

export const OnderwijsIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c0 1.1 2.7 3 6 3s6-1.9 6-3v-5" /></Icon>
);

export const SportIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><circle cx="12" cy="12" r="10" /><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" /><path d="M2 12h20" /></Icon>
);

export const HorecaIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M3 2l2 18h14l2-18" /><path d="M3 7h18" /><path d="M8 2v5" /><path d="M16 2v5" /><path d="M12 2v5" /></Icon>
);

export const OverigIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><polyline points="13 2 13 9 20 9" /></Icon>
);

// --- Voorzieningen ---

export const HuisartsIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3" /><path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4" /><circle cx="20" cy="10" r="2" /></Icon>
);

export const ZiekenhuisIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M12 7v10" /><path d="M7 12h10" /></Icon>
);

export const ApotheekIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M10.5 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v2" /><circle cx="17" cy="17" r="5" /><path d="M17 14v6" /><path d="M14 17h6" /></Icon>
);

export const SupermarktIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></Icon>
);

export const BasisschoolIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></Icon>
);

export const MiddelbareSchoolIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c0 1.1 2.7 3 6 3s6-1.9 6-3v-5" /></Icon>
);

export const OvHalteIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><rect x="3" y="3" width="18" height="13" rx="2" /><path d="M3 9h18" /><circle cx="7" cy="20" r="2" /><circle cx="17" cy="20" r="2" /><path d="M5 16h14" /></Icon>
);

export const GemeentehuisIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M3 21h18" /><path d="M5 21V7l7-4 7 4v14" /><path d="M9 21v-6h6v6" /><line x1="9" y1="10" x2="9" y2="10.01" /><line x1="15" y1="10" x2="15" y2="10.01" /></Icon>
);

// --- Organisaties ---

export const ScholenIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c0 1.1 2.7 3 6 3s6-1.9 6-3v-5" /></Icon>
);

export const ZorgInstellingenIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M19.5 12.572l-7.5 7.428-7.5-7.428A5 5 0 1 1 12 6.006a5 5 0 1 1 7.5 6.572" /></Icon>
);

export const SportVerenigingenIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5C7 4 7 7 7 7" /><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5C17 4 17 7 17 7" /><path d="M4 22h16" /><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" /><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" /><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" /></Icon>
);

export const CultureleOrganisatiesIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M2 16.1A5 5 0 0 1 5.9 20M9.9 20a5 5 0 0 1 3.9-3.9M15.8 20a5 5 0 0 1 3.9-3.9" /><path d="M2 12.05A5 5 0 0 1 9.9 12M13.8 12a5 5 0 0 1 3.9-3.9" /><path d="M2 8a5 5 0 0 1 7.9-.1" /><circle cx="12" cy="4" r="2" /></Icon>
);

// --- BedrijvenOverpass-specific ---

export const DetailhandelIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M3 9l1-4h16l1 4" /><path d="M3 9v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9" /><path d="M9 21V13h6v8" /><path d="M3 9c0 1.1.9 2 2 2s2-.9 2-2" /><path d="M7 9c0 1.1.9 2 2 2s2-.9 2-2" /><path d="M11 9c0 1.1.9 2 2 2s2-.9 2-2" /><path d="M15 9c0 1.1.9 2 2 2s2-.9 2-2" /></Icon>
);

export const LogistiekIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><rect x="1" y="3" width="15" height="13" rx="1" /><path d="M16 8h4l3 3v5h-7V8z" /><circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" /></Icon>
);

export const DienstverleningIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" /><line x1="12" y1="12" x2="12" y2="12.01" /></Icon>
);

export const AgrarischIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M12 22c0-4-3-7.5-3-12a3 3 0 0 1 6 0c0 4.5-3 8-3 12z" /><path d="M7 20c-1.5-2-3-5-3-8a5 5 0 0 1 5-5" /><path d="M17 20c1.5-2 3-5 3-8a5 5 0 0 0-5-5" /></Icon>
);

export const AmbachtIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" /></Icon>
);

export const EnergieIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></Icon>
);

// --- Generic fallback ---

export const PinIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></Icon>
);

// --- Lookup maps ---

export const CATEGORY_ICON_MAP: Record<string, React.FC<IconProps>> = {
  kantoren: KantorenIcon,
  retail: RetailIcon,
  industrie: IndustrieIcon,
  zorg: ZorgIcon,
  onderwijs: OnderwijsIcon,
  sport: SportIcon,
  horeca: HorecaIcon,
  overig: OverigIcon,
};

export const VOORZIENING_ICON_MAP: Record<string, React.FC<IconProps>> = {
  huisarts: HuisartsIcon,
  ziekenhuis: ZiekenhuisIcon,
  apotheek: ApotheekIcon,
  supermarkt: SupermarktIcon,
  basisschool: BasisschoolIcon,
  middelbare_school: MiddelbareSchoolIcon,
  ov_halte: OvHalteIcon,
  gemeentehuis: GemeentehuisIcon,
};

export const ORGANISATIE_ICON_MAP: Record<string, React.FC<IconProps>> = {
  scholen: ScholenIcon,
  zorginstellingen: ZorgInstellingenIcon,
  sportverenigingen: SportVerenigingenIcon,
  culturele_organisaties: CultureleOrganisatiesIcon,
};

export const BEDRIJVEN_OVERPASS_ICON_MAP: Record<string, React.FC<IconProps>> = {
  detailhandel: DetailhandelIcon,
  horeca: HorecaIcon,
  industrie: IndustrieIcon,
  ambacht: AmbachtIcon,
  energie: EnergieIcon,
  logistiek: LogistiekIcon,
  zorg: ZorgIcon,
  dienstverlening: DienstverleningIcon,
  agrarisch: AgrarischIcon,
};
